import React from "react";
import { fmtDate } from "../lib/format";
import { Broadcast, PaperPlaneTilt, Clock, Flame, Rocket } from "@phosphor-icons/react";

const Metric = ({ label, value, testid, accent, icon }) => (
  <div className="px-5 py-3 border-l border-zinc-800/80 first:border-l-0 flex-1 min-w-[140px]" data-testid={testid}>
    <div className="overline flex items-center gap-1.5">{icon}{label}</div>
    <div className="mono text-lg font-semibold mt-0.5" style={accent ? { color: accent } : undefined}>{value}</div>
  </div>
);

export default function CommandBar({ stats, onScan, scanning, onBlast, blasting, newLeadsWithEmail = 0 }) {
  const s = stats || {};
  const last = s.last_scan;
  const batchOn = !!s.batchdata_configured;
  const resendOn = !!s.resend_configured;
  return (
    <div className="border-b border-zinc-800/80 bg-[#0c0c0f]/95 sticky top-0 z-30 backdrop-blur" data-testid="command-bar">
      <div className="flex flex-col lg:flex-row lg:items-stretch">
        <div className="px-4 lg:px-6 py-3 lg:border-r border-zinc-800/80 flex flex-col justify-center border-b lg:border-b-0">
          <div className="overline">Portfolio Console</div>
          <div className="text-base lg:text-lg font-semibold tracking-tight">Live portfolio feed</div>
        </div>

        <div className="flex-1 flex items-stretch overflow-x-auto scroll-y">
          <Metric label="Total" value={s.total_leads ?? 0} testid="metric-total" />
          <Metric label="HOT" value={s.counts?.hot_deals ?? 0} testid="metric-hot" accent="#10b981" icon={<Flame size={11} weight="fill" />} />
          <Metric label="Sent" value={s.emails_sent ?? 0} testid="metric-sent" icon={<PaperPlaneTilt size={11} />} />
          <Metric label="Sent Today" value={s.emails_sent_today ?? 0} testid="metric-sent-today" accent="#34d399" icon={<PaperPlaneTilt size={11} weight="fill" />} />
          <Metric label="FU Queue" value={s.follow_ups_queued ?? 0} testid="metric-queued" icon={<Clock size={11} />} />
          <Metric label="Replies" value={s.emails_received ?? 0} testid="metric-replies" />
        </div>

        <div className="px-3 lg:px-4 py-2 lg:py-0 flex flex-wrap items-center gap-2 lg:gap-4 lg:border-l border-t lg:border-t-0 border-zinc-800/80">
          <div className="text-right leading-tight hidden xl:block">
            <div className="overline flex items-center gap-1.5 justify-end">
              <span className="pulse-dot" style={{ color: batchOn ? "#10b981" : "#71717a", background: batchOn ? "#10b981" : "#71717a" }} />
              BatchData
            </div>
            <div className="text-[11px] text-zinc-500 mono">{last ? `last ${fmtDate(last.started_at)}` : "no scans yet"}</div>
          </div>
          <div className="text-right leading-tight hidden xl:block">
            <div className="overline flex items-center gap-1.5 justify-end">
              <span className="pulse-dot" style={{ color: resendOn ? "#10b981" : "#f59e0b", background: resendOn ? "#10b981" : "#f59e0b" }} />
              Resend
            </div>
            <div className="text-[11px] text-zinc-500 mono">{resendOn ? "live" : "mock mode"}</div>
          </div>

          <button
            data-testid="btn-run-scan"
            onClick={onScan}
            disabled={scanning}
            className="border border-emerald-500/60 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-300 px-3 py-2 text-[11px] mono uppercase tracking-[0.15em] rounded-sm flex items-center gap-2 transition-colors disabled:opacity-50"
          >
            <Broadcast size={13} weight="bold" /> {scanning ? "Scanning…" : "Run Scan"}
          </button>

          {onBlast && (
            <button
              data-testid="btn-blast"
              onClick={onBlast}
              disabled={blasting || newLeadsWithEmail === 0}
              title={newLeadsWithEmail === 0 ? "No New Leads with an owner email on file" : `Blast offers to top ${Math.min(10, newLeadsWithEmail)} eligible leads`}
              className="border border-amber-500/60 bg-amber-500/10 hover:bg-amber-500/20 text-amber-300 px-3 py-2 text-[11px] mono uppercase tracking-[0.15em] rounded-sm flex items-center gap-2 transition-colors disabled:opacity-40"
            >
              <Rocket size={13} weight="bold" /> {blasting ? "Blasting…" : "Blast Offers"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
